module.exports = __webpack_public_path__ + "img/booking-opened-pink.5d0daf2c.svg";